var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12268_2959)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_12268_2959_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.01875 0 0 0.01875 23 23)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1320,
    y: -1320,
    width: 2640,
    height: 2640
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(107, 96, 255, 0) 0deg,rgba(107, 96, 255, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 45.5C10.5733 45.5 0.5 35.4268 0.5 23C0.5 10.5733 10.5733 0.5 23 0.5C35.4268 0.5 45.5 10.5733 45.5 23C45.5 35.4268 35.4268 45.5 23 45.5ZM23 41C27.7739 41 32.3523 39.1036 35.7279 35.7279C39.1036 32.3523 41 27.7739 41 23C41 18.2261 39.1036 13.6477 35.7279 10.2721C32.3523 6.89642 27.7739 5 23 5C18.2261 5 13.6477 6.89642 10.2721 10.2721C6.89642 13.6477 5 18.2261 5 23C5 27.7739 6.89642 32.3523 10.2721 35.7279C13.6477 39.1036 18.2261 41 23 41Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.41960784792900085,\"g\":0.37647059559822083,\"b\":1.0,\"a\":0.0},\"position\":0.0},{\"color\":{\"r\":0.41960784792900085,\"g\":0.37647059559822083,\"b\":1.0,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.41960784792900085,\"g\":0.37647059559822083,\"b\":1.0,\"a\":0.0},\"position\":0.0},{\"color\":{\"r\":0.41960784792900085,\"g\":0.37647059559822083,\"b\":1.0,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":37.500003814697266,\"m01\":1.3306715972161154e-11,\"m02\":4.2499976158142090,\"m10\":-1.3883163715866509e-11,\"m11\":37.500003814697266,\"m12\":4.2499990463256836},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_12268_2959_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 45.5C10.5733 45.5 0.5 35.4268 0.5 23C0.5 10.5733 10.5733 0.5 23 0.5C35.4268 0.5 45.5 10.5733 45.5 23C45.5 35.4268 35.4268 45.5 23 45.5ZM23 41C27.7739 41 32.3523 39.1036 35.7279 35.7279C39.1036 32.3523 41 27.7739 41 23C41 18.2261 39.1036 13.6477 35.7279 10.2721C32.3523 6.89642 27.7739 5 23 5C18.2261 5 13.6477 6.89642 10.2721 10.2721C6.89642 13.6477 5 18.2261 5 23C5 27.7739 6.89642 32.3523 10.2721 35.7279C13.6477 39.1036 18.2261 41 23 41Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12268_2959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.cf1efde8.svg";
export { ForwardRef as ReactComponent };